import { createApi } from '../createApi';
import * as dummy from '../dummy/pricing';
import * as real from '../api/pricing';

const api = createApi(dummy, real);

/** 가격 서비스 — API_DOCS: 6. 가격 조회 / 20. 관리자 - 가격 */
export const pricingService = {
  /* 서비스 (유저용) */
  search: api.searchPrice,
  getOptions: api.getOptions,
  getSurcharges: api.getSurcharges,
  getServiceConfig: api.getServiceConfig,
  getServiceOptions: api.getServiceOptions,
  getServiceSurcharges: api.getServiceSurcharges,
  getVehicleInfo: api.getVehicleInfo,
  getRegionalPricing: api.getRegionalPricing,
  getBookingFormConfig: api.getBookingFormConfig,
  getWeekdaySurcharges: api.getWeekdaySurcharges,

  getRefundPolicy: api.getRefundPolicy,
  getLandingGallery: api.getLandingGallery,
  getLandingVehicleSlides: api.getLandingVehicleSlides,
  getLandingServiceFeatures: api.getLandingServiceFeatures,

  /* 할인 코드 (프로모/쿠폰) */
  validateCoupon: api.validateCoupon,

  /* 약관 */
  getPaymentTerms: api.getPaymentTerms,

  /* 관리자 - 공항 */
  adminGetAirportPricing: api.getAdminAirportPricing,
  adminUpdateAirportPricing: api.updateAdminAirportPricing,

  /* 관리자 - 골프 추천 가격 */
  adminGetGolfPricing: api.getAdminGolfPricing,
  adminCreateGolfPricing: api.createAdminGolfPricing,
  adminUpdateGolfPricing: api.updateAdminGolfPricing,
  adminDeleteGolfPricing: api.deleteAdminGolfPricing,

  /* 관리자 - 골프 지역 일괄가 */
  adminGetGolfRegionalPricing: api.getAdminGolfRegionalPricing,
  adminUpdateGolfRegionalPricing: api.updateAdminGolfRegionalPricing,

  /* 관리자 - 부가옵션 */
  adminGetOptions: api.getAdminOptions,
  adminCreateOption: api.createAdminOption,
  adminUpdateOption: api.updateAdminOption,
  adminDeleteOption: api.deleteAdminOption,

  /* 관리자 - 조건별/현장 추가요금 */
  adminGetConditionalSurcharges: api.adminGetConditionalSurcharges,
  adminUpdateConditionalSurcharges: api.adminUpdateConditionalSurcharges,
  adminGetOnsiteSurcharges: api.adminGetOnsiteSurcharges,
  adminUpdateOnsiteSurcharges: api.adminUpdateOnsiteSurcharges,

  /* 관리자 - 골프/병원 지역별 편집용 가격 */
  adminGetGolfRegionalEditable: api.adminGetGolfRegionalPricing,
  adminGetHospitalRegionalEditable: api.adminGetHospitalRegionalPricing,
  adminUpdateHospitalRegionalPricing: api.adminUpdateHospitalRegionalPricing,

  /* 관리자 - 반려동물 가격 */
  adminGetPetPricing: api.getAdminPetPricing,
  adminUpdatePetPricing: api.updateAdminPetPricing,

  /* 관리자 - 비즈니스 가격 (BugHerd #60) */
  adminGetBusinessPricing: api.getAdminBusinessPricing,
  adminUpdateBusinessPricing: api.updateAdminBusinessPricing,

  /* 관리자 - 스키 가격 */
  adminGetSkiPricing: api.getAdminSkiPricing,
  adminUpdateSkiPricing: api.updateAdminSkiPricing,

  /* 관리자 - 쿠폰 */
  adminGetCoupons: api.getAdminCoupons,
  adminCreateCoupon: api.createAdminCoupon,
  adminGetCoupon: api.getAdminCoupon,
  adminUpdateCoupon: api.updateAdminCoupon,
  adminDeleteCoupon: api.deleteAdminCoupon,
  adminGetCouponUsages: api.getAdminCouponUsages,
};
